
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Banner from '../Components/Banner';
import BannerImage from "../Images/contact-banner.jpg";
import { Col, Container, Row, Image } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVolumeControlPhone } from '@fortawesome/free-solid-svg-icons';
import Contact1 from "../Images/contact/1.jpg";
import Contact2 from "../Images/contact/2.jpg";
import Contact3 from "../Images/shapes/6.png";
import "./Css/Contact.css";
import FormSec from "../Components/Form";

const Contact = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);
  const columnWidth = 6;
  const bannerTitle = (
    <>
      Contact Us
    </>
  );
  const bannerContent = "";
  const bannerConclude = "";
  
  return (
    <div className='home-content'>
      <Banner image={BannerImage} propAlt={"Home Banner"} 
          bannerTitle={bannerTitle} bannerContent={bannerContent} bannerConclude={bannerConclude} />
      <section className='section-pad contact-1'>
        <Container>
          <Row className='d-flex align-items-center'>
            <Col lg={6} xs={12}>
              <div className='contact-left-cont'>
                <h3 className='red-text'>How to find us</h3>
                <h3 className='title'>Hours & Location</h3>
                <p>
                We are open for table service Everyday 9:00am – 6:00pm.
                </p>
                <p>
                Ista, kaakatiya hills, 460, Road No. 9, near Ista, Kakatiya Hills, Madhapur, Hyderabad, Telangana 500081
                </p>
                <ul className='d-flex gap-3 no-padding mt-5'>
                  <li>
                    <a className="btn-style" href='/' title='Get Directions'>
                      Get Directions
                    </a>
                  
                  </li>
                  <li>
                  <a className="btn-style gallery-btn gap-2 d-flex align-items-center" href='/' title='Make a Call'>
                      <FontAwesomeIcon icon={faVolumeControlPhone} />
                      Make a Call
                    </a>
                  </li>
                </ul>
              </div>
            </Col>
            <Col lg={6} xs={12}>
              <div className='contact-right-cont'>
                <Image src={Contact1} rounded  alt="Contact us" />
                <Image className='contact-img-2' src={Contact2} rounded  alt="Contact us" />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className='section-pad contact-2 pos-rel' id="enquiry">
          <Row className="d-flex align-items-stretch justify-content-center contact-2">
            <Col xs={12} lg={6} className="d-flex flex-column justify-content-center h-100 mb-4 mb-lg-0 no-padding">
              <img className="img-responsive w-100" src={Contact1} alt="" />
            </Col>

            <Col xs={12} lg={6} className="d-flex flex-column justify-content-between h-100 no-padding">
            <img className="img-responsive w-100 h-100 object-fit-cover opacity-6" src={Contact3} alt="" />
            </Col>            
          </Row>
          <div className='form'>
            <FormSec columnWidth={columnWidth} />
          </div>
      </section>
    </div>
  )
}

export default Contact